import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Редактировать запись",
    loading: _ctx.is_loading,
    onCancel: _ctx.onCancel,
    onSubmit: _ctx.onSubmit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_new_input, {
          placeholder: "Номер телефона",
          value: _ctx.state.phoneNumber,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.phoneNumber) = $event)),
          "is-invalid": _ctx.state_form$.phoneNumber.$error,
          "validation-errors": _ctx.state_form$.phoneNumber.$errors
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_new_select, {
          placeholder: "Статус",
          loading: _ctx.statuses_state.is_loading,
          failed: _ctx.statuses_state.is_failed,
          disabled: _ctx.is_loading,
          searchable: false,
          options: _ctx.statuses_state.list,
          value: _ctx.state.processingStatusId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.processingStatusId) = $event)),
          onRefresh: _ctx.loadStatuses
        }, null, 8, ["loading", "failed", "disabled", "options", "value", "onRefresh"]),
        _createVNode(_component_new_input, {
          placeholder: "Дата",
          value: _ctx.state.value,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.value) = $event)),
          type: "date"
        }, null, 8, ["value"]),
        _createVNode(_component_new_input, {
          placeholder: "Комментарий",
          value: _ctx.state.comment,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.comment) = $event))
        }, null, 8, ["value"])
      ])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onSubmit"]))
}